import {registerRoute as workbox_routing_registerRoute} from '/app/static/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/app/static/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/app/static/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/app/static/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/app/static/node_modules/workbox-core/clientsClaim.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();



workbox_routing_registerRoute(/.(?:png|gif|jpe?g|svgz?|webp|woff2|mp4|webm|css|js)$/, new workbox_strategies_CacheFirst({ "cacheName":"naacp-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 100, purgeOnQuotaError: true })] }), 'GET');
workbox_routing_registerRoute(/https:\/\/cloud.typography.com\/6627856\/7664832\/css\/fonts.css/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"naacp-fonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 100, purgeOnQuotaError: true })] }), 'GET');
workbox_routing_registerRoute(/https:\/\/use.typekit.net\/xks6cjl.css/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"naacp-fonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 100, purgeOnQuotaError: true })] }), 'GET');




